import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { WalletCardAction, WalletCardType } from "../../../Wallet/types";
import { selectorEmbeddedCardStatus } from "../../selectors/selectorEmbeddedCardStatus";
import { sendMessageToParent } from "../../utils/postMessage";

const STATUS_AFTER_ACTION: Record<
  WalletCardAction,
  cardApiSpec.PaymentCardStatus
> = {
  activated: "Active",
  pin_changed: "Active",
  suspended: "Inactive",
  reactivated: "Active",
  closed: "Closed"
};

export const sendCardOrderedToParent = (card: cardApiSpec.Card) =>
  sendMessageToParent("cardOrdered", {
    cardType: card.isVirtualCard
      ? WalletCardType.Virtual
      : WalletCardType.Physical,
    status: selectorEmbeddedCardStatus(card.status)
  });

export const sendCardUpdatedToParent = (
  cardType: WalletCardType,
  action: WalletCardAction
) =>
  sendMessageToParent("cardUpdated", {
    cardType,
    action,
    status: selectorEmbeddedCardStatus(STATUS_AFTER_ACTION[action])
  });
